import { render, staticRenderFns } from "./uCheckbox.vue?vue&type=template&id=bd130184&scoped=true&"
import script from "./uCheckbox.vue?vue&type=script&lang=js&"
export * from "./uCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd130184",
  null
  
)

export default component.exports